<template>
  <div v-if="unsubscribing">
    <SimpleLayout class="full-viewport-container">
      <div class="text-center flex-1 my-auto">
        <i class="fas fa-5x fa-spinner"></i>
        <p id="cancel-label">{{ $t('network.user.unsubscribingNotification') }}</p>
      </div>
    </SimpleLayout>
  </div>
  <div v-else>
    <DefaultLayout>
      <header slot="header" class="header compact text-white" style="background-color: #76a49f;">
        <div class="container text-center">
          <div class="row">
            <div class="col-md-8 mx-auto">
              <h1>{{ $t('network.user.unsubscribeNotification') }}</h1>
            </div>
          </div>
        </div>
      </header>

      <section class="section bg-gray pt-5">
        <div class="container-fluid text-center">
          <button id="unsubscribe" data-test="unsubscribe" class="btn btn-danger" @click="unsubscribe">{{ $t('network.user.unsubscribe') }}</button>
        </div>
      </section>
    </DefaultLayout>
  </div>
</template>
<script>
import DefaultLayout from '../layouts/default/';
import SimpleLayout from '../layouts/simple/';

export default {
  components: {
    DefaultLayout,
    SimpleLayout,
  },
  data() {
    return {
      unsubscribing: true,
      event_id: this.$route.params.event,
      network_id: this.$route.query.network_id,
    };
  },
  created() {
    this.unsubscribe();
  },
  methods: {
    unsubscribe() {
      if (!this.$auth.auth) {
        this.unsubscribing = false;
        let msg = this.$t('network.auth.needToLoginBeforeUnsubscribe');
        this.$bus.emit('show-sign-in', '/unsubscribe-notification/' + this.event_id + '?network_id=' + this.network_id, msg);
        return;
      }
      this.axios.post('/auth/notification-preferences/unsubscribe/' + this.event_id, { network_id: this.network_id }).then(() => {
        let msg = this.$t('network.user.unsubscribeNotificationSuccess');
        this.$swal.fire({
          icon: 'success',
          title: msg,
        });
        this.$router.push('/profile');
      });
    },
  },
};
</script>